import { DesignWrapComponentProps } from "common/components/types";

const WrapComponent = (props: DesignWrapComponentProps) => {
  const { id, property } = props;

  return (
    <div id={id} className="flex-row-center w-full h-full">
      <p
        className="select-none m-0 align-middle whitespace-pre-line"
        style={{
          fontFamily: property.style.text.fontFamily,
          letterSpacing: property.style.text.letterSpacing,
          fontSize: property.style.text.fontSize,
          color: property.style.text.color,
          textAlign: "center",
          opacity: property.style.text.opacity / 100,
          textShadow:
            property.style.text.textShadowRadius !== 0 &&
            `${property.style.text.textShadowOffset.width}px ${property.style.text.textShadowOffset.height}px ${property.style.text.textShadowRadius}px ${property.style.text.textShadowColor}`,
        }}
      >
        {property.text}
      </p>
    </div>
  );
};

export default WrapComponent;
